import Link from "next/link";
import ArrowIcon from "@/components/icons/arrow";
import ExtendedImage from "@/components/ui/extended-image";

export interface ConsultingSearchResult {
  id: string;
  slug: string;
  title: string;
  summary?: string;
  description?: string;
  image: string;
}

interface SearchConsultingCardProps {
  item: ConsultingSearchResult;
}

const SearchConsultingCard = ({ item }: SearchConsultingCardProps) => {
  const href = item.slug.startsWith("/") ? item.slug : `/${item.slug}`;
  const description = item.summary || item.description;

  return (
    <div className="relative flex items-center p-6 md:p-8 justify-end gap-4 w-full h-52 md:h-60 rounded-2xl overflow-hidden border border-neutral-200 bg-neutral-50 shadow-xs">
      <div className="w-1/2 h-full flex flex-col justify-center items-start gap-2 relative z-10 pr-2">
        <h2 className="text-xl md:text-2xl font-bold text-neutral-900 line-clamp-2">
          {item.title}
        </h2>
        {description ? (
          <p className="text-sm md:text-base leading-snug font-medium text-neutral-700 line-clamp-2">
            {description}
          </p>
        ) : null}
        <Link
          className="mt-1 rounded-full bg-brand-blue-600 hover:bg-brand-blue-700 text-white w-fit px-5 py-2 flex flex-row gap-2 justify-center items-center text-sm font-semibold transition-colors cursor-pointer"
          href={href}
        >
          Detaylı Bilgi <ArrowIcon className="stroke-white size-3.5" />
        </Link>
      </div>
      {item.image && (
        <ExtendedImage
          alt={item.title}
          className="absolute inset-0 h-full w-full object-cover object-left z-0 pointer-events-none rounded-2xl"
          fill={true}
          src={item.image}
        />
      )}
    </div>
  );
};

export default SearchConsultingCard;
